import { ActionType } from "../interfaces/api/actionType";

export const PostWhatsappUser: ActionType = {
  FAILURE: "POST_WHATSAPP_USER_FAILURE",
  REQUEST: "POST_WHATSAPP_USER_REQUEST",
  SUCCESS: "POST_WHATSAPP_USER_SUCCESS",
};

export const GetWhatsappConversations: ActionType = {
  FAILURE: "GET_WHATSAPP_CONVERSATIONS_FAILURE",
  REQUEST: "GET_WHATSAPP_CONVERSATIONS_REQUEST",
  SUCCESS: "GET_WHATSAPP_CONVERSATIONS_SUCCESS",
};

export const GetConversationSummary: ActionType = {
  FAILURE: "GET_CONVERSATION_SUMMARY_FAILURE",
  REQUEST: "GET_CONVERSATION_SUMMARY_REQUEST",
  SUCCESS: "GET_CONVERSATION_SUMMARY_SUCCESS",
};

export const ClearWhatsappConversations: ActionType = {
  FAILURE: "CLEAR_WHATSAPP_CONVERSATIONS_FAILURE",
  REQUEST: "CLEAR_WHATSAPP_CONVERSATIONS_REQUEST",
  SUCCESS: "CLEAR_WHATSAPP_CONVERSATIONS_SUCCESS",
};
